import { DASH } from "@/constants/testIds";

export default function YoYBlock({ yoy }) {
  if (!yoy) return null;

  const { months_tracked = 0, has_full_year = false, pairs = [] } = yoy;

  return (
    <div data-testid={DASH.yoyBlock} className="flat-card p-6 sm:p-8">
      <div className="flex items-baseline justify-between flex-wrap gap-2 mb-4">
        <div>
          <div className="overline mb-2">Longitudinal</div>
          <h3 className="font-display text-2xl tracking-tight">Year over year</h3>
        </div>
        <span className="font-mono-data text-xs text-[#6E716C]">
          {months_tracked} / 12 months on file
        </span>
      </div>

      {pairs.length === 0 ? (
        <EmptyYoy hasFullYear={has_full_year} monthsTracked={months_tracked} />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {pairs.map((p) => (
            <div key={p.month} className="border-l-2 border-l-[#0F3524] pl-4 py-1">
              <div className="font-mono-data text-xs text-[#6E716C]">
                {p.month} vs {p.prev_month}
              </div>
              <div className="mt-2 space-y-1">
                <Row label="kWh" v={p.kwh_pct} suffix="%" />
                <Row label="Cost" v={p.cost_pct} suffix="%" />
                <Row label="CO₂" v={p.co2_pct} suffix="%" />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Row({ label, v, suffix = "" }) {
  const color = v > 0 ? "text-[#B24F35]" : v < 0 ? "text-[#8FA38B]" : "text-[#6E716C]";
  const sign = v > 0 ? "▲" : v < 0 ? "▼" : "•";
  return (
    <div className="flex items-baseline justify-between text-sm">
      <span className="text-[#6E716C] font-mono-data text-xs">{label}</span>
      <span className={`font-mono-data ${color}`}>
        {sign} {typeof v === "number" ? Math.abs(v).toFixed(2) : "—"}{suffix}
      </span>
    </div>
  );
}

function EmptyYoy({ hasFullYear, monthsTracked }) {
  const remaining = Math.max(0, 12 - monthsTracked);
  return (
    <div className="py-4">
      <p className="text-sm text-[#6E716C] max-w-lg">
        {hasFullYear
          ? "No matching months across two calendar years yet. Once you upload bills that span the same month in two different years, comparisons will appear here."
          : `${remaining} more monthly bill${remaining === 1 ? "" : "s"} to unlock year-over-year comparisons.`}
      </p>
    </div>
  );
}
